import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Location } from '@angular/common';
import { Invoice } from '../../invoice/invoice';
import { InvoiceService } from '../../invoice/invoice.service';
import { Po } from '../../po/po';
import { AuthService } from '../../auth.service';
import { PoService } from '../../po/po.service';

@Component({
  selector: 'app-po-approver-dashboard',
  templateUrl: './po-approver-dashboard.component.html',
  styleUrls: ['./po-approver-dashboard.component.css']
})
export class PoApproverDashboardComponent implements OnInit {

  invoice = new Invoice();
  po = new Po();
  dashboardcountspo: any = {};
  dashboardcountsinvoice: any = {};
  awaitedpolist: any = [];
  recentactionlist: any = [];

  constructor(
    private invoiceService: InvoiceService,
    private poService: PoService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private auth: AuthService
  ) { }

  ngOnInit() {
    this.getDashboardCountsPO()
    this.getDashboardCountsInvoice()
    this.GetApprovalPO()
    this.getApproverRecentAction()
  }
  getDashboardCountsPO() {
    return this.poService.getDashboardCountsPO(this.auth.currentUserValue.userid)
      .subscribe(
        counts => {
          this.dashboardcountspo = counts[0];
        }
      );
  }
  GetApprovalPO() {
    console.log('Stev.....', this.auth.currentUserValue);
    if (this.auth.currentUserValue.userroleid == 7) {
      return this.poService.GetApprovalPOlevel1(this.auth.currentUserValue.userid)
        .subscribe(
          polist => {
            this.awaitedpolist = polist;
            console.log("This should be the response???: ", this.awaitedpolist);
          }
        );
    } else {
      return this.poService.GetApprovalPO(this.auth.currentUserValue.userid)
        .subscribe(
        polist => {
            this.awaitedpolist = polist;
           
          }

        );
    }




  }

  getDashboardCountsInvoice() {
    return this.invoiceService.getDashboardCountsFinance()
      .subscribe(
        counts => {
          this.dashboardcountsinvoice = counts[0];
        }
      );
  }
  //Approver Recent Action
  getApproverRecentAction() {
    return this.poService.getApproverRecentAction()
      .subscribe(
        poactionlist => {
          this.recentactionlist = poactionlist;
        }
      );
  }

}
